import * as React from "react";
const ProfileIcon = (props) => (
  <svg
    width={32}
    height={33}
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.4}>
      <path
        d="M12.0001 2.89111C8.50675 2.89111 5.66675 5.73111 5.66675 9.22445C5.66675 12.6511 8.34675 15.4244 11.8401 15.5444C11.9467 15.5311 12.0534 15.5311 12.1334 15.5444C12.1601 15.5444 12.1734 15.5444 12.2001 15.5444C12.2134 15.5444 12.2134 15.5444 12.2267 15.5444C15.6401 15.4244 18.3201 12.6511 18.3334 9.22445C18.3334 5.73111 15.4934 2.89111 12.0001 2.89111Z"
        fill="#344054"
      />
      <path
        d="M12.0001 2.89111C8.50675 2.89111 5.66675 5.73111 5.66675 9.22445C5.66675 12.6511 8.34675 15.4244 11.8401 15.5444C11.9467 15.5311 12.0534 15.5311 12.1334 15.5444C12.1601 15.5444 12.1734 15.5444 12.2001 15.5444C12.2134 15.5444 12.2134 15.5444 12.2267 15.5444C15.6401 15.4244 18.3201 12.6511 18.3334 9.22445C18.3334 5.73111 15.4934 2.89111 12.0001 2.89111Z"
        fill="url(#paint0_linear_3639_300846)"
      />
      <path
        d="M12.0001 2.89111C8.50675 2.89111 5.66675 5.73111 5.66675 9.22445C5.66675 12.6511 8.34675 15.4244 11.8401 15.5444C11.9467 15.5311 12.0534 15.5311 12.1334 15.5444C12.1601 15.5444 12.1734 15.5444 12.2001 15.5444C12.2134 15.5444 12.2134 15.5444 12.2267 15.5444C15.6401 15.4244 18.3201 12.6511 18.3334 9.22445C18.3334 5.73111 15.4934 2.89111 12.0001 2.89111Z"
        fill="url(#paint1_linear_3639_300846)"
      />
      <path
        d="M12.0001 2.89111C8.50675 2.89111 5.66675 5.73111 5.66675 9.22445C5.66675 12.6511 8.34675 15.4244 11.8401 15.5444C11.9467 15.5311 12.0534 15.5311 12.1334 15.5444C12.1601 15.5444 12.1734 15.5444 12.2001 15.5444C12.2134 15.5444 12.2134 15.5444 12.2267 15.5444C15.6401 15.4244 18.3201 12.6511 18.3334 9.22445C18.3334 5.73111 15.4934 2.89111 12.0001 2.89111Z"
        fill="url(#paint2_linear_3639_300846)"
      />
    </g>
    <path
      d="M18.7733 19.0914C15.0533 16.6114 8.98661 16.6114 5.23995 19.0914C3.54661 20.2248 2.61328 21.7581 2.61328 23.3981C2.61328 25.0381 3.54661 26.5581 5.22661 27.6781C7.09328 28.9314 9.54661 29.5581 11.9999 29.5581C14.4533 29.5581 16.9066 28.9314 18.7733 27.6781C20.4533 26.5448 21.3866 25.0248 21.3866 23.3714C21.3733 21.7314 20.4533 20.2114 18.7733 19.0914Z"
      fill="#344054"
    />
    <path
      d="M18.7733 19.0914C15.0533 16.6114 8.98661 16.6114 5.23995 19.0914C3.54661 20.2248 2.61328 21.7581 2.61328 23.3981C2.61328 25.0381 3.54661 26.5581 5.22661 27.6781C7.09328 28.9314 9.54661 29.5581 11.9999 29.5581C14.4533 29.5581 16.9066 28.9314 18.7733 27.6781C20.4533 26.5448 21.3866 25.0248 21.3866 23.3714C21.3733 21.7314 20.4533 20.2114 18.7733 19.0914Z"
      fill="url(#paint3_linear_3639_300846)"
    />
    <path
      d="M18.7733 19.0914C15.0533 16.6114 8.98661 16.6114 5.23995 19.0914C3.54661 20.2248 2.61328 21.7581 2.61328 23.3981C2.61328 25.0381 3.54661 26.5581 5.22661 27.6781C7.09328 28.9314 9.54661 29.5581 11.9999 29.5581C14.4533 29.5581 16.9066 28.9314 18.7733 27.6781C20.4533 26.5448 21.3866 25.0248 21.3866 23.3714C21.3733 21.7314 20.4533 20.2114 18.7733 19.0914Z"
      fill="url(#paint4_linear_3639_300846)"
    />
    <path
      d="M18.7733 19.0914C15.0533 16.6114 8.98661 16.6114 5.23995 19.0914C3.54661 20.2248 2.61328 21.7581 2.61328 23.3981C2.61328 25.0381 3.54661 26.5581 5.22661 27.6781C7.09328 28.9314 9.54661 29.5581 11.9999 29.5581C14.4533 29.5581 16.9066 28.9314 18.7733 27.6781C20.4533 26.5448 21.3866 25.0248 21.3866 23.3714C21.3733 21.7314 20.4533 20.2114 18.7733 19.0914Z"
      fill="url(#paint5_linear_3639_300846)"
    />
    <g opacity={0.4}>
      <path
        d="M26.6532 10.0112C26.8666 12.5979 25.0266 14.8646 22.4799 15.1712C22.4666 15.1712 22.4666 15.1712 22.4532 15.1712H22.4132C22.3332 15.1712 22.2532 15.1712 22.1866 15.1979C20.8932 15.2646 19.7066 14.8512 18.8132 14.0912C20.1866 12.8646 20.9732 11.0246 20.8132 9.02458C20.7199 7.94458 20.3466 6.95791 19.7866 6.11791C20.2932 5.86458 20.8799 5.70458 21.4799 5.65125C24.0932 5.42458 26.4266 7.37125 26.6532 10.0112Z"
        fill="#344054"
      />
      <path
        d="M26.6532 10.0112C26.8666 12.5979 25.0266 14.8646 22.4799 15.1712C22.4666 15.1712 22.4666 15.1712 22.4532 15.1712H22.4132C22.3332 15.1712 22.2532 15.1712 22.1866 15.1979C20.8932 15.2646 19.7066 14.8512 18.8132 14.0912C20.1866 12.8646 20.9732 11.0246 20.8132 9.02458C20.7199 7.94458 20.3466 6.95791 19.7866 6.11791C20.2932 5.86458 20.8799 5.70458 21.4799 5.65125C24.0932 5.42458 26.4266 7.37125 26.6532 10.0112Z"
        fill="url(#paint6_linear_3639_300846)"
      />
      <path
        d="M26.6532 10.0112C26.8666 12.5979 25.0266 14.8646 22.4799 15.1712C22.4666 15.1712 22.4666 15.1712 22.4532 15.1712H22.4132C22.3332 15.1712 22.2532 15.1712 22.1866 15.1979C20.8932 15.2646 19.7066 14.8512 18.8132 14.0912C20.1866 12.8646 20.9732 11.0246 20.8132 9.02458C20.7199 7.94458 20.3466 6.95791 19.7866 6.11791C20.2932 5.86458 20.8799 5.70458 21.4799 5.65125C24.0932 5.42458 26.4266 7.37125 26.6532 10.0112Z"
        fill="url(#paint7_linear_3639_300846)"
      />
      <path
        d="M26.6532 10.0112C26.8666 12.5979 25.0266 14.8646 22.4799 15.1712C22.4666 15.1712 22.4666 15.1712 22.4532 15.1712H22.4132C22.3332 15.1712 22.2532 15.1712 22.1866 15.1979C20.8932 15.2646 19.7066 14.8512 18.8132 14.0912C20.1866 12.8646 20.9732 11.0246 20.8132 9.02458C20.7199 7.94458 20.3466 6.95791 19.7866 6.11791C20.2932 5.86458 20.8799 5.70458 21.4799 5.65125C24.0932 5.42458 26.4266 7.37125 26.6532 10.0112Z"
        fill="url(#paint8_linear_3639_300846)"
      />
    </g>
    <path
      d="M29.32 22.3445C29.2133 23.6378 28.3867 24.7578 27 25.5178C25.6667 26.2512 23.9867 26.5978 22.32 26.5578C23.28 25.6912 23.84 24.6112 23.9467 23.4645C24.08 21.8112 23.2933 20.2245 21.72 18.9578C20.8267 18.2512 19.7867 17.6912 18.6533 17.2778C21.6 16.4245 25.3067 16.9978 27.5867 18.8378C28.8133 19.8245 29.44 21.0645 29.32 22.3445Z"
      fill="#344054"
    />
    <path
      d="M29.32 22.3445C29.2133 23.6378 28.3867 24.7578 27 25.5178C25.6667 26.2512 23.9867 26.5978 22.32 26.5578C23.28 25.6912 23.84 24.6112 23.9467 23.4645C24.08 21.8112 23.2933 20.2245 21.72 18.9578C20.8267 18.2512 19.7867 17.6912 18.6533 17.2778C21.6 16.4245 25.3067 16.9978 27.5867 18.8378C28.8133 19.8245 29.44 21.0645 29.32 22.3445Z"
      fill="url(#paint9_linear_3639_300846)"
    />
    <path
      d="M29.32 22.3445C29.2133 23.6378 28.3867 24.7578 27 25.5178C25.6667 26.2512 23.9867 26.5978 22.32 26.5578C23.28 25.6912 23.84 24.6112 23.9467 23.4645C24.08 21.8112 23.2933 20.2245 21.72 18.9578C20.8267 18.2512 19.7867 17.6912 18.6533 17.2778C21.6 16.4245 25.3067 16.9978 27.5867 18.8378C28.8133 19.8245 29.44 21.0645 29.32 22.3445Z"
      fill="url(#paint10_linear_3639_300846)"
    />
    <path
      d="M29.32 22.3445C29.2133 23.6378 28.3867 24.7578 27 25.5178C25.6667 26.2512 23.9867 26.5978 22.32 26.5578C23.28 25.6912 23.84 24.6112 23.9467 23.4645C24.08 21.8112 23.2933 20.2245 21.72 18.9578C20.8267 18.2512 19.7867 17.6912 18.6533 17.2778C21.6 16.4245 25.3067 16.9978 27.5867 18.8378C28.8133 19.8245 29.44 21.0645 29.32 22.3445Z"
      fill="url(#paint11_linear_3639_300846)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3639_300846"
        x1={5.66675}
        y1={2.89111}
        x2={5.66675}
        y2={15.5444}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FECFEF" />
        <stop offset={1} stopColor="#FF989C" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3639_300846"
        x1={5.66675}
        y1={2.89111}
        x2={18.3201}
        y2={15.5578}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F74FAC" />
        <stop offset={1} stopColor="#FCB24F" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3639_300846"
        x1={5.66675}
        y1={2.89111}
        x2={18.3201}
        y2={15.5578}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#72EDF2" />
        <stop offset={1} stopColor="#5151E5" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3639_300846"
        x1={2.61328}
        y1={17.2314}
        x2={2.61328}
        y2={29.5581}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FECFEF" />
        <stop offset={1} stopColor="#FF989C" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3639_300846"
        x1={2.61328}
        y1={17.2314}
        x2={13.9243}
        y2={34.4579}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F74FAC" />
        <stop offset={1} stopColor="#FCB24F" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3639_300846"
        x1={2.61328}
        y1={17.2314}
        x2={13.9243}
        y2={34.4579}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#72EDF2" />
        <stop offset={1} stopColor="#5151E5" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_3639_300846"
        x1={18.8132}
        y1={5.6333}
        x2={18.8132}
        y2={15.2049}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FECFEF" />
        <stop offset={1} stopColor="#FF989C" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_3639_300846"
        x1={18.8132}
        y1={5.6333}
        x2={28.2013}
        y2={13.3395}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F74FAC" />
        <stop offset={1} stopColor="#FCB24F" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_3639_300846"
        x1={18.8132}
        y1={5.6333}
        x2={28.2013}
        y2={13.3395}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#72EDF2" />
        <stop offset={1} stopColor="#5151E5" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_3639_300846"
        x1={18.6533}
        y1={16.8906}
        x2={18.6533}
        y2={26.5609}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FECFEF" />
        <stop offset={1} stopColor="#FF989C" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_3639_300846"
        x1={18.6533}
        y1={16.8906}
        x2={28.276}
        y2={27.5193}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F74FAC" />
        <stop offset={1} stopColor="#FCB24F" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_3639_300846"
        x1={18.6533}
        y1={16.8906}
        x2={28.276}
        y2={27.5193}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#72EDF2" />
        <stop offset={1} stopColor="#5151E5" />
      </linearGradient>
    </defs>
  </svg>
);
export default ProfileIcon;
